import { css } from 'emotion';

export const totalEventsTooltip = css`
  vertical-align: middle;
  display: inline-block;
  margin-left: 10px;
`;

export const tooltipContent = css`
  width: 240px;
  > span {
    margin-bottom: 10px;
  }
`;
